import { useEffect } from 'react';
import { Redirect } from 'react-router';
import { useIntl } from 'react-intl';
// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { Helmet, isInternalURL } from '@plone/volto/helpers';
import {
  NormalizableContent,
  transformToCard,
} from '@fhnw/helpers/DesignSystem/cardTransformers';

const OccasionView = ({
  token,
  content,
}: {
  token?: string;
  content: Content;
}) => {
  const intl = useIntl();
  const parentId = content?.parent?.['@id'];
  let redirectUrl: string | null = null;

  // Redirect logic for unauthenticated users only
  if (!token) {
    const card = transformToCard(content as NormalizableContent, intl);
    if (
      card?.actions &&
      card?.actions?.length > 0 &&
      !card.actions[0].disabled &&
      typeof card.actions[0]?.href === 'string'
    ) {
      // If registration is active, redirect to registration link
      redirectUrl = card.actions[0].href;
    } else if (parentId) {
      // Otherwise, redirect to parent (event or product)
      redirectUrl = parentId;
    }

    // Handle fragment and querystring redirects (prepend parent URL)
    if (redirectUrl && redirectUrl.match(/^(#|\?)/)) {
      if (parentId) {
        redirectUrl = parentId + redirectUrl;
      } else {
        redirectUrl = null;
      }
    }
  }

  useEffect(() => {
    if (!redirectUrl || isInternalURL(redirectUrl)) {
      return;
    }
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {redirectUrl && isInternalURL(redirectUrl) && (
        <Redirect to={redirectUrl as string} />
      )}
    </>
  );
};

export default OccasionView;
